export class AuditableEntity {
  createdBy?: string;
  createdByName?: string;
  createdDate?: Date;
  updatedBy?: string;
  updatedByName?: string;
  updatedDate?: Date;
}
